import React, { lazy } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Section, SectionHeading } from './shared';
// 15 — REAL TEAM · [Trust] [Branding]
// Real photos + verified bios only. No AI portraits. No invented awards.
// team{name,role,bio,image}
const team = [{
  name: 'Tony Separovic',
  role: 'Principal & Founder',
  bio: 'Founded the practice in 1990 and is one of Perth’s most senior injury lawyers. Admitted in 1985, Tony is a hard, experienced negotiator with a focus on car accident and work injury claims.',
  image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=480&q=75'
}, {
  name: 'Aimee Schmidt',
  role: 'Partner',
  bio: 'A partner known by clients for meticulous attention to detail and steady, compassionate guidance through the claims process.',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=480&q=75'
}, {
  name: 'Veronica Lam',
  role: 'Partner',
  bio: 'A partner who supports injured clients through complex claims with clear, plain-English advice and determined representation.',
  image: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?auto=format&fit=crop&w=480&q=75'
}, {
  name: 'Nick Lindsay',
  role: 'Special Counsel',
  bio: 'Special Counsel bringing senior experience to the firm’s personal injury and compensation matters.',
  image: 'https://images.unsplash.com/photo-1556157382-97eda2d62296?auto=format&fit=crop&w=480&q=75'
}, {
  name: 'Stephanie Reeves',
  role: 'Senior Associate',
  bio: 'A senior associate who manages claims end to end and keeps clients informed at every stage.',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=480&q=75'
}, {
  name: 'Andrew Cavenagh',
  role: 'Senior Associate',
  bio: 'A senior associate focused on building strong, well-evidenced claims for injured Western Australians.',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=480&q=75'
}];
export function TeamSection() {
  return <Section id="team" data-id="element-403">
      <SectionHeading eyebrow="Our team" title="Meet the People Who Will Help You" intro="A named legal team based in our Highgate office — senior lawyers, expert paralegals and dedicated support staff who will know your claim personally." data-id="element-404" />

      <ul className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-405">
        {team.map((m, i) => <li key={i} data-id="element-406">
            <article className="flex h-full flex-col overflow-hidden rounded-card border border-ink/5 bg-paper shadow-card transition-transform duration-200 hover:-translate-y-1" data-id="element-407">
              <div className="aspect-[4/5] w-full overflow-hidden bg-forest/5" data-id="element-408">
                <img src={m.image} alt={`Portrait of ${m.name}, ${m.role} at Separovic Injury Lawyers`} width={480} height={600} loading="lazy" className="h-full w-full object-cover" data-id="element-409" />
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-410">
                <h3 className="text-h4 font-semibold text-ink" data-id="element-411">{m.name}</h3>
                <p className="mt-0.5 text-small font-semibold uppercase tracking-wide text-gold" data-id="element-412">
                  {m.role}
                </p>
                <p className="mt-3 text-body text-slate" data-id="element-413">{m.bio}</p>
                <a href="/our-lawyers/" className="mt-auto inline-flex items-center gap-2 rounded pt-5 text-body font-semibold text-forest hover:text-signal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal" data-id="element-414">
                  View profile
                  <ArrowRightIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-415" />
                </a>
              </div>
            </article>
          </li>)}
      </ul>
    </Section>;
}